import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { guaranteePeriod } from '../data/landing';
export function GuaranteeSection() {
  return <section id="garantia" className="bg-cream pb-14 sm:pb-20" data-id="element-47" data-mp="4vjmq3szb4em">
      <div className="mx-auto max-w-2xl px-5 sm:px-8" data-id="element-48" data-mp="9tbdguhw0kh8">
        <div className="flex flex-col items-start gap-4 rounded-3xl bg-sage-soft p-6 sm:flex-row sm:items-center sm:gap-6 sm:p-8" data-id="element-49" data-mp="9wpe9yawklmk">
          <span className="grid h-12 w-12 shrink-0 place-items-center rounded-2xl bg-white text-sage shadow-card" data-id="element-50" data-mp="jtc28vyizsst">
            <ShieldCheckIcon className="h-6 w-6" strokeWidth={2.1} data-id="element-51" data-mp="nt2pwqsr9st4" />
          </span>
          <div data-id="element-52" data-mp="skkppbj1lnci">
            <h2 className="font-display text-xl font-semibold tracking-tight text-petrol sm:text-2xl" data-id="element-53" data-mp="sm5jv01g349u">
              Probalo sin riesgo.
            </h2>
            <p className="mt-2 font-sans text-[15px] leading-relaxed text-petrol/80" data-id="element-54" data-mp="12j0dp5mrwghs">
              Tenés garantía de {guaranteePeriod}. Si dentro de ese plazo decidís que no es para vos,
              escribinos por email y gestionamos la devolución de tu pago.
            </p>
          </div>
        </div>
      </div>
    </section>;
}